export const TorneoVacio = {
  temporada: '',
  anioInicio: null,
  mesInicio: null,
  diaInicio: null,
  fechaFin: null,
  categoria: null,
  tipoTorneo: null,
  pais: null,
  nombre: '',
  cantidadParticipantes: null,
};

export const torneoToDTO = (torneo) => {
  return {
    anioInicio: torneo.anioInicio,
    mesInicio: torneo.mesInicio,
    diaInicio: torneo.diaInicio,
    fechaFin: torneo.fechaFin,
    codCategoria: torneo.categoria ? torneo.categoria.codigo : null,
    codTipoTorneo: torneo.tipoTorneo ? torneo.tipoTorneo.codigo : null,
    idPais: torneo.pais ? torneo.pais.id : null,
    descripcion: torneo.nombre,
    temporada: torneo.temporada,
    cantidadParticipantes: torneo.cantidadParticipantes,
  };
};

export const patchTorneoDatosBasicos = (torneo) => {
  return {
    descripcion: torneo.descripcion,
    codTipoTorneo: torneo.tipoTorneo ? torneo.tipoTorneo.codigo : null,
    idPais: torneo.pais ? torneo.pais.id : null,
    codCategoria: torneo.categoria ? torneo.categoria.codigo : null,
    codOrganizador: torneo.organizador ? torneo.organizador.codigo : null,
    idDivision: torneo.division ? torneo.division.id : null,
    idTrofeo: torneo.trofeo ? torneo.trofeo.codigo : null,
    observaciones: torneo.observaciones,
    dudas: torneo.dudas,
  };
};

export const patchTorneoFechas = (torneo) => {
  return {
    temporada: torneo.temporada,
    anioInicio: torneo.anioInicio,
    mesInicio: torneo.mesInicio,
    diaInicio: torneo.diaInicio,
    fechaFin: torneo.fechaFin,
  };
};
